module.exports = __webpack_public_path__ + "static/img/icon-vip.eec1533.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon-vip.png
// module id = +UYF
// module chunks = 1